import { Box } from '@chakra-ui/react';
import React, { useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { KeypadContext, ReadAloudController } from '@3plearning/question-components-library';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import css from './activity.scss';
import { disableSpinner } from '../mle/mle-actions';
import { LEARNOSITY_SPINNER } from '../../helpers/constants';
import Congratulations from '../../components/congratulations/congratulations';
import Conquest from '../conquest/conquest';
import { Keypad } from '../conquest/keypad';
import ErrorBoundary from '../error-boundary/error-boundary';

const Activity = ({ readAloudConfig }) => {
  const dispatch = useDispatch();
  const { stepsCompleted } = useSelector(state => state.activityReducer);
  const { description, stepCount } = useSelector(state => state.mleReducer || {});
  const { questions } = useSelector(state => state.activityReducer);
  const { questionBodyRef } = useContext(KeypadContext);
  const [questionVariantId, setQuestionVariantId] = React.useState('questionVariantId');

  const isJourneyCompleted = stepCount && (stepsCompleted === stepCount);

  useEffect(() => {
    if (isJourneyCompleted) {
      dispatch(disableSpinner(LEARNOSITY_SPINNER));
    }
  }, [stepsCompleted, stepCount]);

  useEffect(() => {
    if (questions.length > 0 && questions[0] && questions[0].conquest) {
      setQuestionVariantId(questions[0].conquest.questionVariant.id);
    }
  }, [questions]);

  return (
    <div className={classNames(css.activity, { [css.completed]: isJourneyCompleted })}>
      {
        !isJourneyCompleted && <Box position={'absolute'} left={'-20px'} top={'20px'} zIndex={1}>
          <ReadAloudController
            readAloudConfig={readAloudConfig}
            containerId={'new-content-activity'}
            key={questionVariantId}
          />
        </Box>
      }
      <Keypad />
      <div className={classNames(css['inner-scroll'], { [css.completed]: isJourneyCompleted })} ref={questionBodyRef}>
        {
          !isJourneyCompleted && (
            <ErrorBoundary>
              <Conquest
                readAloudConfig={readAloudConfig}
              />
            </ErrorBoundary>
          )
        }
        {
          isJourneyCompleted && <Congratulations description={description} stepCount={stepCount} />
        }
      </div>
    </div>
  );
};

Activity.propTypes = {
  readAloudConfig: PropTypes.object
};

export default Activity;
